import lazadaorders from '../../api/moudles/lazadaorders.js'
import order from '../../api/moudles/order.js'
import {
	Message
} from 'element-ui'
import utils from '../../utils/utils.js'

import {
	SET_ITEMS,
	SET_TTP,
	SET_HAS_PRINTED,
	SET_HAS_PRINTED_READY,
	SET_SECONDE_PICKTIME,
	INIT_DATA,
	FAST_PRINT,
	UPDATA_PAGE,
	SET_LAZADA_PROCESSED_ORDER
} from '../mutation-types'


const state = {
	orderList: [],
	buttonList: [],
	buttonMapList: [],
	activeList: [],
	success_list:[],
	error_list:[],
	orderUrl:'',
	totalNum:0,
	isDone:false,
	falg:false,
	aleadyGenaratedNum:[],
	generateOrderId:[],
	successList:[],
	activeValue:null,
	activeIndex:null,
	storeItemsInfo:[],
	aleadyGetlogist:false,
	packagelist:[],
	alreadyLoaded:false,
	orderList2:[],
	userFlags:[],
	flashPage:[],
	storeItemsData:[]
}

const getters = {

}

const actions = {

	//待处理页面，每个订单获取仓库信息
	getStoreItem({state,commit,dispatch}, payload) {
		lazadaorders
		.getstoreitembyid(payload)
		.then(res => {
			if (res.code === 200) {
				console.log('storeItem44',res.data)
			    state.storeItemsData=res.data
				state.unprocessedOrderList.forEach(k => {
					k.items.forEach(p => {
						if(!p.storeItem || p.storeItem== null || p.storeItem== undefined){
							// console.log(this.storeItemsData)
							p.storeItem=state.storeItemsData[shopSku]
						}
					})
				})
			}
		})
	},
	//lazada获取仓库帐号的待处理订单--高级查询页面
	getStoreOrders({state,commit,dispatch},payload){
		lazadaorders
		.getStoreOrders(payload)
		.then(res => {
			if(res.code === 200) {
				state.orderList = res.data;
				console.log('仓库帐号下的待审核订单',state.orderList)
				state.buttonList = [];
				for (let i = 0; i < 8; i++) {
					state.buttonList.push(new Map())
					state.activeList.push('all')
				}
				// state.activeList[2]='unsent'
				
				
				//选择店铺
				state.orderList.forEach((order) => {

					order.orderItems.forEach(k => {
						state.storeItemsInfo.push({
							shopSku:k.shopSku,
						})	
					})
					
					order.shipByDate=utils.renderTimeDate(order.shipByDate)
					let shopIdMap = state.buttonList[0];
					let shopIdList = shopIdMap.get(order.storeId);
					if (shopIdList == null || shopIdList == "undifined") {
						shopIdList = [];
					}
					shopIdList.push(order);
					shopIdMap.set(order.storeId, shopIdList)
					state.buttonList[0] = shopIdMap;
					
				})


				dispatch('getStoreItem',state.storeItemsInfo)
				
				
								
				
				let list = [];
				let flag = true;
				let firstShopId=0;
				state.buttonList[0].forEach((value, key) => {
					if(firstShopId==0){
						firstShopId=key
					}
					let active = (key == firstShopId)
					if (active == true) {
						flag = false
					}
					list.push({
						'key': key,
						'value': value,
						'isActive': active
					})
				})
				if (flag) {
					list[0].isActive = true;
				}
				state.buttonMapList.push(list);
				console.log('asfdsafg a', state.buttonList);
				
				
				
				
				
				
				
				
				
				commit(SET_LAZADA_PROCESSED_ORDER, {
					orders: state.buttonList[0].get(firstShopId),
					// orders:state.buttonList[2].get('unsent'),
					index: 0
				})
				
			}
		})
	},
	//更新旗帜描述
	updataUserFlageDesc({state,commit,dispatch}, payload) {
		print
		.updataUserFlageDesc(payload)
		.then(res => {
			if (res.code === 200) {
				console.log('更新旗帜描述',res.data)
			}
		})
	},
	//获取用户旗帜
	getUserFlags({state,commit,dispatch}, payload) {
		print
		.getUserFlags(payload)
		.then(res => {
			if (res.code === 200) {
				console.log('获取用户旗帜',res.data)
				state.userFlags=res.data
			}
		})
	},
	//增加用户的旗帜
	addUserFlags({state,commit,dispatch}, payload) {
		print
		.addUserFlags(payload)
		.then(res => {
			if (res.code === 200) {
				console.log('增加用户旗帜',res.data)
			}
		})
	},
	
	//设置旗帜
	setOrderFlag({state,commit,dispatch}, payload) {
		print
		.setOrderFlag(payload)
		.then(res => {
			if (res.code === 200) {
				console.log('设置旗帜',res.data)
			}
		})
	},
	
	//开始准备订单数据,带参数
	startReadyOrders({state,commit,dispatch}, payload) {
		print
			.startReadyOrders(payload)
			.then(res => {
				if (res.code === 200) {
					state.aleadyGenaratedNum=[]
					let orderIds=payload.map(p => {
						return p.orderId
					})
					state.generateOrderId=orderIds
					console.log('开始准备订单数据',orderIds)
					setTimeout(() => {
						dispatch('getNewOrders',orderIds)
					},1000)
					
				}
			})
	},
	
	//点击开始生成运单号，再调此方法获取最新的订单
	getNewOrders({state,dispatch},payload) {
		print
		.getNewOrders(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('最新订单',res.data)
				console.log(state.generateOrderId)
				
				let newData=res.data
				newData.forEach(p => {
					state.generateOrderId.forEach((k,index) => {
						if(k === p.orderId && p.ready == true && p.image!== null){
							state.aleadyGenaratedNum.push(p)
							state.alreadyLoaded=true
							state.generateOrderId.splice(index,1)
						}
					})
				})
				console.log(state.generateOrderId)
				if(state.generateOrderId.length> 0){
					dispatch('getNewOrders',state.generateOrderId)
				}
				
				
				
			}
		})
	},
	
	
	storeReceived({state},payload) {
		order
		.storeReceived(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('仓库收到代打包运单',res.data)
				Message({
					message: '确认收货成功',
					type: 'success'
				})
				console.log(payload.trackingCode)
				if(res.data.length){
					state.orderList.forEach(p => {
						p.orderPackages.forEach((j,index) => {
							if(j.trackingCode == payload.trackingCode){
								console.log(index)
								j.packStatus= "RECEIVED"
							}
						
						})
						
					})
				}
			}
		})
	},
	//根据打包运单号查询订单
	getOrderByPackageTrackingCode({state,dispatch},payload) {
		order
		.getOrderByPackageTrackingCode(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('根据打包运单号查询订单',res.data)
				// let falg=res.data[0]
				// console.log('根据打包运单号查询订单',falg)
				// if(falg.orderId){
				// 	state.orderList.forEach(p => {
				// 		p.orderPackages.forEach(k => {
				// 			falg.orderPackages.forEach(j => {
				// 				if(k.trackingCode === j.trackingCode){
				// 					k.packStatus=j.packStatus
				// 				}
				// 			})
				// 		})
						
				// 	})
				// }
			}
		})
	},
	//新增代打包运单号
	addOrderPackage({state},payload) {
		order
		.addOrderPackage(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('代打印运单号',res.data)
				Message({
					message: '添加成功！',
					type: 'success'
				})
				if(res.data.orderId){
					state.orderList.forEach(p => {
						if(p.orderId === res.data.orderId){
							p.orderPackages.push(res.data)
						}
					})
				}
			}
		})
	},
	
	//删除代打包的运单号
	deleteorderpackage({state},payload) {
		order
		.deleteorderpackage(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('删除代打包的运单号',payload)
				Message({
					message: '成功删除',
					type: 'success'
				})
				
				state.orderList.forEach((p) => {
					p.orderPackages.forEach((k,index) => {
						if(k.trackingCode === payload.trackingCode){
							p.orderPackages.splice(index,1)
						}
					})
				})
				
				
			}
		})
	},
	//异步获取取件方式
	getLogisticInfo({state,commit,dispatch}, payload) {
		print
			.getLogisticInfo(payload)
			.then(res => {
				if (res.code === 200) {
					
					state.orderList.forEach(p => {
						if(p.orderId === payload.orderId) {
							p.logisticInfo=res.data
							setTimeout(() => {
								state.aleadyGetlogist=true
							},1000)
						}
					})
					
					
					
				}
			})
	},
	
	
	
	//印尼用户扫描打包出库
	printMergerOrders({state,dispatch},payload){
		print
		.printMergerOrders(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('合并打印订单',res.data)
				if(res.data){
					state.error_list=res.data.errorOrder
					state.success_list=res.data.successOrder
					state.orderUrl=res.data.successUrl
					state.totalNum=payload.length
				}
			}
		})
	},
	//印尼用户扫描打包出库
	setPackaged({state},payload){
		print
		.setPackaged(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('扫描打包出库',res.data)
				state.packagelist=[]
				state.packagelist.push(res.data)
				console.log('扫描打包出库',state.packagelist)
				state.buttonMapList[7].forEach(p => {
					if(p.isActive){
						p.value.forEach(k => {
							if (k.orderId == res.data.orderId) {
								k.packaged = true
							}
						})
					}
				})
				Message({
					message: '订单成功出库！',
					type: 'success'
				})
				state.falg=true
			}else{
				Message({
					message: res.msg,
					type: 'error'
				})
				state.falg=true
			}
		})
	},
	
	//安排订单
	arrangement({
		state,
		commit
	}, payload) {
		print
			.arrangement(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('安排订单',res.data)

				}
			})
	},
	//增加打印次数
	addPrintNum({
		state,
		commit
	}, payload) {
		print
			.addPrintNum(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('增加了打印次数')

				}
			})
	},

	//lazada卖家获取所有待处理的订单
	getProcessedOrders({
		state,
		dispatch,
		commit
	}, payload) {
		lazadaorders
			.getProcessedOrders(payload)
			.then(res => {
				if (res.code === 200) {

					state.orderList = res.data;
					console.log('Lazada获取所有订单1', state.orderList)
					let shopIds=utils.getAllshop().map(p => {return p.value}).slice(1)
					//设置订单在不设置安排时间下的情况下，默认为隔天安排
					commit(SET_SECONDE_PICKTIME)
					
				
					state.buttonList = [];
					for (let i = 0; i < 8; i++) {
						state.buttonList.push(new Map())
						state.activeList.push('all')
					}
					
					//选择店铺
					state.orderList.forEach((order) => {

						order.orderItems.forEach(k => {
							state.storeItemsInfo.push({
								shopSku:k.shopSku,
							})	
						})
						
				
						
						order.shipByDate=utils.renderTimeDate(order.shipByDate)
						let shopIdMap = state.buttonList[0];
						let shopIdList = shopIdMap.get(order.shopId);
						if (shopIdList == null || shopIdList == "undifined") {
							shopIdList = [];
						}
						shopIdList.push(order);
						shopIdMap.set(order.shopId, shopIdList)
						state.buttonList[0] = shopIdMap;
					})



					console.log('storeItemsInfo',state.storeItemsInfo)
					dispatch('getStoreItem',state.storeItemsInfo)
				
					
					let list = [];
					let flag = true;
					let firstShopId=0;
					state.buttonList[0].forEach((value, key) => {
						if(firstShopId==0){
							firstShopId=key
						}
						let active = (key == firstShopId)
						if (active == true) {
							flag = false
						}
						list.push({
							'key': key,
							'value': value,
							'isActive': active
						})
					})
					if (flag) {
						list[0].isActive = true;
					}
					state.buttonMapList.push(list);
			
					console.log('asfdsafg a', state.buttonList);
					console.log('asfdsafg a', state.buttonMapList[0]);
					console.log('asfdsafg a', shopIds);
					commit(SET_LAZADA_PROCESSED_ORDER, {
						orders: state.buttonList[0].get(firstShopId),
						index: 0
					})



				}
			})
	},

}

const mutations = {
	[SET_ITEMS]: (state) => {
		state.pendingprocess = []
		state.arr.forEach(p => {
			state.pendingprocess.push(p)
		})

	},
	[SET_LAZADA_PROCESSED_ORDER]: (state, data) => {
		console.log(data.orders)
		console.log(data.index)
		let index = data.index
		let orderList = [];
		
		if (index > 0) {
			orderList = state.buttonList[index].get(data.orders)
			
		} else {
			orderList = data.orders
		}
		
		for (let i = index + 1; i < 8; i++) {
			state.buttonList[i] = new Map();
			if (i > 0) {
				state.buttonList[i].set("all", orderList)
			}
		}
		console.log(orderList)
		state.orderList2=orderList
		
		if(orderList !== undefined){
			
			orderList.forEach((order) => {
			
			
				//选择仓库
				if (index < 1) {
					let storeIdMap = state.buttonList[1]
					let storeList = storeIdMap.get(order.storeId)
					if (storeList == null || storeList == "undifined") {
						storeList = [];
					}
					storeList.push(order);
					storeIdMap.set(order.storeId, storeList)
					state.buttonList[1] = storeIdMap;
				}
				//加载状态
				if (index < 2) {
					let loadStatusMap = state.buttonList[2]
					let orderkey=order.sent ? (order.ready?'ready':'unready') :'unsent'
					let loadStatusList = loadStatusMap.get(orderkey)
					
					if (loadStatusList == null || loadStatusList == "undifined") {
						loadStatusList = [];
					}
					loadStatusList.push(order);
					loadStatusMap.set(orderkey, loadStatusList)
					state.buttonList[2] = loadStatusMap;
				}
				
				//打印状态
				if (index < 3) {
					let printStatusMap = state.buttonList[3]
					let printStatusList = printStatusMap.get(order.printed)
					if (printStatusList == null || printStatusList == "undifined") {
						printStatusList = [];
					}
					printStatusList.push(order);
					printStatusMap.set(order.printed, printStatusList)
					state.buttonList[3] = printStatusMap;
				}
				//物流类型
				if (index < 4) {
					let logisticsStatusMap = state.buttonList[4]
					let logisticsStatusList = logisticsStatusMap.get(order.logistics)
					if (logisticsStatusList == null || logisticsStatusList == "undifined") {
						logisticsStatusList = [];
					}
					logisticsStatusList.push(order);
					logisticsStatusMap.set(order.logistics, logisticsStatusList)
					state.buttonList[4] = logisticsStatusMap;
				}
				//最后发货
				if (index < 5) {
					let shipbydateMap = state.buttonList[5]
					let shipbydateList = shipbydateMap.get(order.shipByDate)
					if (shipbydateList == null || shipbydateList == "undifined") {
						shipbydateList = [];
					}
					shipbydateList.push(order);
					shipbydateMap.set(order.shipByDate, shipbydateList)
					
					state.buttonList[5] = shipbydateMap;
					
				}
			
				//订单状态 
				if (index < 6) {
					let orderStatusMap = state.buttonList[6]
					let orderStatusList = orderStatusMap.get(order.orderStatus)
					if (orderStatusList == null || orderStatusList == "undifined") {
						orderStatusList = [];
					}
					orderStatusList.push(order);
					orderStatusMap.set(order.orderStatus, orderStatusList)
					state.buttonList[6] = orderStatusMap;
				}
			
				//sku状态
				if (index < 7) {
					let skuQuantityMap = state.buttonList[7]
					let skuQuantityList = skuQuantityMap.get(order.itemNum == 1 ? "oneSku" : "someSku")
					if (skuQuantityList == null || skuQuantityList == "undifined") {
						skuQuantityList = [];
					}
					skuQuantityList.push(order);
					skuQuantityMap.set(order.itemNum == 1 ? "oneSku" : "someSku", skuQuantityList)
					state.buttonList[7] = skuQuantityMap;
				}
			
			
			})
			
			for (let j = 1; j < 8; j++) {
				state.buttonMapList[j] = null
			}
			state.buttonMapList.length = 1
			
			state.buttonList.forEach((map, i) => {
				let list = [];
				let flag = true;
				if (i != 0 ) {
					map.forEach((value, key) => {
						let active = (key == state.activeList[i])
						if (active == true) {
							flag = false
						}
						list.push({
							'key': key,
							'value': value,
							'isActive': active
						})
					})
					if (flag) {
						list[0].isActive = true;
					}
					state.buttonMapList.push(list);
				}
			
			})
			
			console.log('adcvrfasdasbtr', state.buttonMapList);
			
			    let un_sent=null
			    for (var i = 0; i < state.buttonMapList[2].length; i++) {
			      if (state.buttonMapList[2][i].key == 'unsent') {
			         un_sent=i;
			      }
			    }
			   
			  
			  console.log(un_sent);
			
			if(un_sent === null){
				state.buttonMapList[2].push({
					isActive:false,
					key:'unsent',
					value:[]
				})
			}
			
			
			
			
			state.buttonMapList[5].sort((a,b) => {
				return a.key>b.key ? -1 : 1 
			})
			state.isDone=true
			
			
			
			console.log('adcvrfasdasbtr', state.buttonMapList);
			console.log('adcvrfbtr', state.buttonList);
		}else{
			state.buttonMapList.forEach((p,index) => {
				if(index >2){
					p=[{
						isActive:true,
						key:"all",
						value:[]
					}]
				}
			})
			
		}

		
		
		
	
		

		

	},
	[SET_HAS_PRINTED]: (state, arr) => {
		let list = []
		state.orderList.forEach(p => {
			arr.forEach(j => {
				if (p.orderId == j) {
					p.printed = true
					list.push(p)
				}
			})
		})
		console.log('hfjnvhfjkv', list)
	},
	
	[SET_HAS_PRINTED_READY]: (state, arr) => {
		let list = []
		state.orderList.forEach(p => {
			arr.forEach(j => {
				if (p.orderId == j) {
					p.sent = true
					list.push(p)
				}
			})
		})
	},
	[SET_SECONDE_PICKTIME]:(state) => {
		state.orderList.forEach(p =>{
			if(p.logisticInfo !== null){
				if(p.logisticInfo.pickup.address_list.length > 0){
					p.logisticInfo.pickup.address_list.forEach(k => {
						if(k.address_flag.indexOf('pickup_address') > -1) {
							if(k.time_slot_list instanceof Array ){
								p.logisticInfo.info_needed.methods=JSON.stringify({orderId:p.orderId,pickupTimeId:k.time_slot_list.length >0 ? k.time_slot_list[0].pickup_time_id: '',addressId:k.address_id,type:1})
							}else if(k.time_slot_list instanceof Object && k.time_slot_list.error ==="error_expired"){
								p.logisticInfo.info_needed.methods=JSON.stringify({orderId:p.orderId,type:0})
							}
						}
					})
				}
					
			}
		})
	},
	[INIT_DATA]:(state) => {
		state.success_list=[],
		state.error_list=[],
		state.orderUrl='',
		state.totalNum=0,
		state.falg=false
		state.alreadyLoaded=false
	},
	[FAST_PRINT]:(state,arr) => {
		state.success_list=arr
		state.totalNum=arr.length
		state.orderUrl=true
		
	},
	[UPDATA_PAGE]:(state,list) => {//储存获取到的旗帜
		state.flashPage=list
		console.log(state.flashPage)
		
		
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
